import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "fury-service-provider-table",
  templateUrl: "./service-provider-table.component.html",
  styleUrls: ["./service-provider-table.component.scss"],
})
export class ServiceProviderTableComponent implements OnInit {
  @Input() dataSource: any[] = [];
  @Output() handlePaymentInfo = new EventEmitter();
  @Input() searchForm : FormGroup;
  @Input() isLoading = false;
  @Output() search = new EventEmitter<any>();
  @Input() itemList = [];
  displayedColumns = [
    "companyName",
    "serviceAreas",
    "companyAddress",
    "state",
    "zipCode",
    "companyPhone",
    "companyEmail",
    "workOrderEmailAddress",
    "workOrderPhoneNumber",
    "companyLicense",
    "actions",
  ];

  constructor(public apiService: ApiService) {}

  ngOnInit(): void {}
  handlePayment(row) {
    this.handlePaymentInfo.emit(row?.companyId);
  }
  searchData() {
    if (!this.isLoading) this.search.emit(this.searchForm.value);
  }
}
